import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'

/**
 * 全部设备过期超 30 天且无有效未绑单时的落地页（与 SpyX 一致）。
 * 页面本身只是个空壳：弹窗由 VerticalLayout 内的 ExpiredPurchaseGuide（SEVERE）统一渲染。
 *
 * ⚠️ 这个文件不能删：useExpiredPurchaseGuide / navigation / pages/index 都会把用户跳到这里，
 * 缺了它会被 pages/[slug].js（博客页）接住。
 */
const ExpiredPurchasePage = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setCurrentTab(''))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch])

  return <div className='min-h-[calc(var(--vh2)*100-200px)] w-full' aria-hidden />
}

export default ExpiredPurchasePage
